import { render, staticRenderFns } from "./purchaseChequesHistory.vue?vue&type=template&id=7641636b"
import script from "./purchaseChequesHistory.vue?vue&type=script&lang=js"
export * from "./purchaseChequesHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports